/**
 * @implements {Implementation}
 */
const glassboxImplementation = {
  id: 'Glassbox',
  available: () =>
    new Promise(resolve => {
      const ATTEMPTS = 3;
      const BASE_WAIT_TIME_SECONDS = 1;
      if (window?._detector) {
        resolve(true);
        return;
      }

      const toMilliseconds = s => s * 1000;
      const wait = (seconds, attempts, i = 1) => {
        setTimeout(() => {
          if (window?._detector) {
            resolve(true);
            return;
          }

          if (i >= attempts) {
            resolve(false);
            return;
          }

          const step = i + 1;
          const nextWaitSeconds = seconds * 2;
          wait(nextWaitSeconds, attempts, step);
        }, toMilliseconds(seconds));
      };

      wait(BASE_WAIT_TIME_SECONDS, ATTEMPTS);
    }),
  send: ({ key, value }) => {
    window._detector.triggerCustomEvent(key, value);
  },
};

export { glassboxImplementation };
